import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { DeficienciesService } from '../services/sections/deficiencies/deficiencies.service';
import { Deficiency } from '../models/deficiencies/deficiency.model';
import { DeficiencyItem } from '../models/deficiencies/deficiency-item.model';

@Injectable({
	providedIn: 'root'
})
export class DeficienciesListResolver implements Resolve<Observable<DeficiencyItem[]>> {

	constructor(
		private router: Router,
		private deficienciesService: DeficienciesService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.deficienciesService.getDeficienciesList(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				map(response => response.deficiencies)
			);
	}
}
